import "https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js";
import "https://api.mapbox.com/mapbox.js/v3.3.1/mapbox.js";
import GeoMap from "./map.js";
import ProjectCollection from "./project-collection.js";
import Result from "./result.js";
import ResultList from "./result-list.js";
import Filter from "./filter.js";
import createElement from "./create-element.js";
import "/src/assets/styles/index.css";

let map, projectCollection, filter;

const addProjects = async () => {
  const projects = await getProjects();
  map.addProjects(projects);
  projectCollection = new ProjectCollection(projects.map(({ id, properties }) => ({ id, ...properties })));
};

const getProjects = async () => {
  const response = await fetch("/projects/projects.json");
  const featureCollection = await response.json();
  return featureCollection.features;
};

const autoSuggest = (text) => {
  if (filter) filter.hide();
  navbar.classList.remove("rounded-bottom");
  let results = projectCollection.search(text);

  results = results
    .filter(({ matchedProperties }) => matchedProperties.includes("name") || matchedProperties.includes("location"))
    .map(({ description, matchedProperties, ...rest }) => rest);

  autoSuggestion.classList.remove("hide");
  autoSuggestionList.populate(results, text);
};

const initialiseFilter = () => {
  filter = new Filter(document.querySelector(".filter"), {
    ...projectCollection.getRanges(),
    sharesStatus: "All",
    projectCount: projectCollection.projects.length
  });

  filter.addObserver("input", (values) => {
    const resultCount = projectCollection.filter(values).length;
    filter.updateResultCount(resultCount);
  });

  filter.addObserver("submit", (values) => {
    navbar.classList.add("rounded-bottom");
    map.filter(projectCollection.matches.filter);
  });
};

const createProjectModalContentElement = (popupContent) => {
  const container = document.createElement("div");
  container.innerHTML = popupContent;
  const projectModalContentElement = container.firstElementChild;
  projectModalContentElement.classList.add("project-modal-content");
  return projectModalContentElement;
};

const createImageViewerCarousel = (carousel) => {
  const imageViewerCarousel = carousel.cloneNode(true);
  const carouselID = "image-viewer-carousel";
  imageViewerCarousel.setAttribute("id", carouselID);
  
  for (const carouselControl of imageViewerCarousel.querySelectorAll(".carousel-control")) {
    carouselControl.setAttribute("href", `#${carouselID}`);
  }
  
  imageViewerCarousel.classList.add("image-viewer-carousel");
  imageViewer.querySelector(".image-viewer-carousel").replaceWith(imageViewerCarousel);
  new bootstrap.Carousel(imageViewerCarousel);
};

const cancelFlashing = () => {
  const flashingMarker = document.querySelector(".marker.flashing");
  if (flashingMarker) flashingMarker.classList.remove("flashing");
};

map = new GeoMap("map");

map.addObserver("marker-click", (popupContent) => {
  const projectModalContentElement = createProjectModalContentElement(popupContent);
  projectModalElement.querySelector(".project-modal-content").replaceWith(projectModalContentElement);
  projectModal.show();
});

map.addObserver("pan", (markerID) => {
  const marker = document.querySelector(`[data-marker-id="marker-${markerID}"]`);
  marker.classList.add("flashing");
});

const zoomControl = {
  zoomIn: document.querySelector("#zoom-in"),
  zoomOut: document.querySelector("#zoom-out")
};

const baseLayerControl = {
  streets: document.querySelector("[data-base-layer='streets']"),
  satellite: document.querySelector("[data-base-layer='satellite']")
};

baseLayerControl.streets.checked = true;

zoomControl.zoomIn.addEventListener("click", () => {
  map.zoomIn();
});

zoomControl.zoomOut.addEventListener("click", () => {
  map.zoomOut();
});

for (const baseLayerName of ["streets", "satellite"]) {
  const layerSelector = baseLayerControl[baseLayerName];

  layerSelector.addEventListener("change", () => {
    const markerBackgroundColor = baseLayerName === "streets" ? "var(--primary)" : "white";
    mapContainer.style.setProperty("--marker-background-color", markerBackgroundColor);
    map.changeBaseLayer(baseLayerName);
  });
}

const mapContainer = document.querySelector("#map");

mapContainer.addEventListener("click", ({ currentTarget, target }) => {
  if (target.tagName === "IMG") {
    const carousel = target.closest(".carousel");
    if (carousel) createImageViewerCarousel(carousel);
  }
  
  cancelFlashing();
  if (currentTarget !== target) return;
  navbar.classList.add("rounded-bottom");
  autoSuggestion.classList.add("hide");
  searchResults.classList.remove("show");
  if (filter) filter.hide();
});

const navbar = document.querySelector("nav");
const filterToggler = document.querySelector("#filter-toggler");
const searchbar = document.querySelector(".searchbar");
const searchField = searchbar.querySelector("input");
const autoSuggestion = document.querySelector("#auto-suggestion");
const autoSuggestionList = new ResultList(document.querySelector("#auto-suggestion-list"), "strong");
const searchResults = document.querySelector("#search-results");
const searchResultList = new ResultList(document.querySelector("#search-result-list"), "mark");
const hideSearchResults = document.querySelector("#search-results header button");
const imageViewer = document.querySelector("#image-viewer");
const projectModalElement = document.querySelector("#project-modal");
const projectModal = new bootstrap.Modal(projectModalElement);

autoSuggestionList.addObserver((projectID, matchedText) => {
  searchField.value = matchedText;
  navbar.classList.add("rounded-bottom");
  autoSuggestion.classList.add("hide");
  searchResults.classList.remove("show");
  if (filter) filter.hide();
  cancelFlashing();
  map.pan(projectID);
});

searchResultList.addObserver((projectID, matchedText) => {
  searchResults.classList.remove("show");
  navbar.classList.add("rounded-bottom");
  cancelFlashing();
  map.pan(projectID);
});

hideSearchResults.addEventListener("click", () => {
  navbar.classList.add("rounded-bottom");
  searchResults.classList.remove("show");
});

searchField.addEventListener("input", (event) => {
  autoSuggest(event.target.value);
});

searchbar.addEventListener("submit", (event) => {
  event.preventDefault();
  const searchText = searchField.value;
  const results = projectCollection.search(searchText);
  navbar.classList.remove("rounded-bottom");
  autoSuggestion.classList.add("hide");
  if (filter) filter.hide();
  searchResults.classList.add("show");
  searchResultList.populate(results, searchText);
});

filterToggler.addEventListener("click", initialiseFilter, { once: true });

filterToggler.addEventListener("click", () => {
  navbar.classList.toggle("rounded-bottom");
  searchResults.classList.remove("show");
  filter.toggle();
});

projectModalElement.addEventListener("click", ({ target }) => {
  if (target.tagName !== "IMG") return;
  createImageViewerCarousel(target.closest(".carousel"));
});

addProjects();
